import axios from "axios";
import { useMemo } from "react";
import { useAuth } from "@clerk/clerk-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Returns an axios instance that automatically attaches the active
// Clerk session token (which carries the active organization claims).
export function useApi() {
  const { getToken } = useAuth();

  return useMemo(() => {
    const instance = axios.create({ baseURL: API });
    instance.interceptors.request.use(async (config) => {
      const token = await getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });
    return instance;
  }, [getToken]);
}
